/**
 * RoleGate — blocks access unless the current user holds a specific Entra App
 * Role (task 3.12; Req 5.1, 5.2).
 *
 * Renders `children` when the user has the role; otherwise renders the
 * `fallback` (typically `AccessDeniedScreen`).
 *
 * Must be rendered INSIDE `EntraAuthProvider` and `RequireAuth` so that
 * `useHasRole` has access to the auth context and a valid token is guaranteed.
 */

import type { ReactNode } from "react";
import { useViewerRole } from "../auth/adapters";

export interface RoleGateProps {
  /** Subtree rendered when the role check passes. */
  children: ReactNode;
  /** UI rendered when the user lacks the required role. */
  fallback: ReactNode;
}

/**
 * Gate that checks the `ViaMind.Viewer` role via the adapters layer. The role
 * constant lives in `adapters.ts` so it is defined in exactly one place.
 */
export default function RoleGate({ children, fallback }: RoleGateProps) {
  const hasRole = useViewerRole();
  return <>{hasRole ? children : fallback}</>;
}
